import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAssetsBySuiteId } from 'src/services/client';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

interface UseAssetAPIReturn {
  asset: any | null;
  area: any | null;
  loadingAsset: boolean;
}

export const useAssetAPI = (
  suiteId: string,
  areaId: string,
  assetId: string
): UseAssetAPIReturn => {
  const user: any = useSelector(selectAuthenticatedUser);

  const [asset, setAsset] = useState<any | null>(null);
  const [area, setArea] = useState<any | null>(null);
  const [loadingAsset, setLoadingAsset] = useState<boolean>(false);

  const fetchAsset = async (): Promise<void> => {
    setLoadingAsset(true);
    try {
      const roleName: string = user?.roles?.[0]?.role?.name;

      const response: any = await getAssetsBySuiteId(suiteId, user.id, roleName);

      if (response.ok || response.status === 200) {
        const responseJson = await response.json();
        const areas: any[] = responseJson.data || [];
        const foundArea = areas.find((a) => a.areaId === areaId) ?? null;
        const foundAsset = foundArea?.assets?.find((a) => a.id === assetId) ?? null;
        setArea(foundArea);
        setAsset(foundAsset);
      } else {
        console.error('Failed to fetch asset');
        setArea(null);
        setAsset(null);
      }
    } catch (error) {
      console.error('Error fetching asset:', error);
      setArea(null);
      setAsset(null);
    } finally {
      setLoadingAsset(false);
    }
  };

  useEffect(() => {
    if (!suiteId || !areaId || !assetId || !user?.id) {
      return;
    }

    fetchAsset();
  }, [suiteId, areaId, assetId, user?.id]);

  return { asset, area, loadingAsset };
};